import type { Award, Photo, ResultDetail } from '../../../../../graphql/rest-link/types';

export type ParticipantDetailsState = {
  photos?: Photo[];
  awards?: Award[];
  resultDetail?: ResultDetail;
};

export type ParticipantDetailsAction =
  | { type: 'setPhotos'; payload: Photo[] }
  | { type: 'setAwards'; payload: Award[] }
  | { type: 'setResultDetail'; payload: ResultDetail };

// NOTE: this reducer is used to store state for the entire application. These are things like
// the current event, user and any other values that are needed throughout the application.
const participantDetailsReducer = (
  state: ParticipantDetailsState,
  action: ParticipantDetailsAction
): ParticipantDetailsState => {
  switch (action.type) {
    case 'setPhotos':
      return {
        ...state,
        photos: action.payload,
      };
    case 'setAwards':
      return {
        ...state,
        awards: action.payload,
      };
    case 'setResultDetail':
      return {
        ...state,
        resultDetail: action.payload,
      };
    default:
      return state;
  }
};

export default participantDetailsReducer;
